"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isWordPress;

var _getLeadinConfig = _interopRequireDefault(require("./getLeadinConfig"));

function isWordPress() {
  try {
    if (window.top !== window) {
      var leadinConfig = (0, _getLeadinConfig.default)();
      return !!leadinConfig.wpVersion;
    }
  } catch (e) {//
  }

  return false;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hubspot-plugin-common/static-1.186/js/checkIfWordPress.js
// module id = 268
// module chunks = 5 6 7